<template>
  <div>
    <h2>{{ label }}</h2>

    <div class="upload-btn-wrapper" v-if="!currentFile">
      <BasicButton class="upload-btn" tag="button" type="attachment"
        >Attach</BasicButton
      >

      <input
        type="file"
        id="file"
        class="file_input"
        @change="handleFileUpload"
      />
    </div>
    <div
      v-if="label == 'CV / Resume *' && errorClass.error == true"
      :class="errorClass"
      class="form-group__message form-group__message--small"
    >
      Please, provide valid CV
    </div>
    <div class="divider--sm"></div>
    <div v-if="currentFile" class="attachment-chip-wrapper">
      <span class="attachment-chip" v-if="currentFile"
        >{{ currentFile.name }}
        <button
          type="button"
          :class="`position-item--${position_color}`"
          @click="removeFile"
        >
          <i class="icons8-jobapp-delete-01"></i></button
      ></span>
    </div>
    <div class="form-group__message" v-if="maxFileSize">
      Max file size is 10mb
    </div>
    <div class="form-group__message" v-if="unsupportedFormat">
      Allowed file types are: zip, rar, 7z, jpg, png, pdf
    </div>
    <span class="attachment-text" v-else
      >Allowed file types: zip, rar, 7z, jpg, png, pdf. Maximum 10 MB.</span
    >

    <LinksPicker
      class="links-picker"
      v-if="label == 'Portfolio / Other Files'"
    />

    <div class="dividing-line"></div>
  </div>
</template>

<script>
import BasicButton from "../BasicButton";
import LinksPicker from "./LinksPicker";

export default {
  name: "file-picker",
  components: {
    BasicButton,
    LinksPicker
  },
  props: {
    errorClass: { type: Object, default: () => {} },
    label: {
      type: String
    },
    value: {},
    position_color: {
      default: 0
    }
  },
  data() {
    return {
      currentFile: null,
      maxFileSize: false,
      unsupportedFormat: false,
      supportedFileFormats: ["zip", "rar", "7z", "jpeg", "jpg", "png", "pdf"]
    };
  },
  methods: {
    handleFileUpload(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (files && files[0]) {
        this.currentFile = files[0];
        let fileFormat = this.currentFile.name.split(".").pop();
        let supportedFileFormat = this.supportedFileFormats.includes(
          fileFormat
        );
        if (!supportedFileFormat) {
          this.unsupportedFormat = true;
          this.currentFile = null;
          this.$emit("input", null);
        } else {
          this.unsupportedFormat = false;
          if (this.currentFile.size > 10000000) {
            this.maxFileSize = true;
            this.currentFile = null;
            this.$emit("input", null);
          } else {
            this.maxFileSize = false;
            this.$emit("input", files[0]);
          }
        }
      }
    },
    removeFile() {
      this.currentFile = null;
      this.$emit("input", null);
    }
  },
  watch: {
    value() {
      this.currentFile = this.value;
    }
  }
};
</script>
<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";

.dividing-line {
  border-bottom: 1px solid #e7e6e6;
  margin-top: 20px;
  margin-bottom: 20px;
}

h2 {
  font-family: "Inter UI", sans-serif;
  font-weight: 400;
  font-size: 22px;
  letter-spacing: 0.02px;
  line-height: 28px;
  color: #1a1a1a;
}

.attachment-text {
  font-family: "Inter UI", sans-serif;
  font-weight: 400;
  line-height: 24px;
  font-size: 14px;
  color: #808080;
}

.attachment-chip-wrapper {
  padding-bottom: 5px;
}

.attachment-chip {
  background: #e2e2e2;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0.02px;
  padding: 10px;

  button {
    border: transparent;
    background-color: transparent;
  }
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;

  .upload-btn {
    min-width: 100%;
    padding-right: 35px;
    padding-left: 35px;
    margin-bottom: 20px;
  }
}

.upload-btn-wrapper input[type="file"] {
  font-size: 200px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.form-group__message {
  color: #c32121;
  font-size: 18px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationPageComponents/FilePicker.vue